const evaluateRegularConditions = ({ operator, compareTo, value, }) => {
    switch (operator) {
        case 'exists':
            return value !== null && value !== undefined;
        case 'equals':
            return value === compareTo;
    }
    if (value === null ||
        value === undefined ||
        compareTo === null ||
        compareTo === undefined) {
        return false;
    }
    if (typeof value === 'number' && typeof compareTo === 'number') {
        switch (operator) {
            case 'greater':
                return value > compareTo;
            case 'greater-equal':
                return value >= compareTo;
            case 'less':
                return value < compareTo;
            case 'less-equal':
                return value <= compareTo;
        }
    }
    if (typeof value === 'string' && typeof compareTo === 'string') {
        switch (operator) {
            case 'contains':
                return value.includes(compareTo);
            case 'starts-with':
                return value.startsWith(compareTo);
            case 'ends-with':
                return value.endsWith(compareTo);
        }
    }
    if (value instanceof Date && compareTo instanceof Date) {
        switch (operator) {
            case 'before':
                return value < compareTo;
            case 'after':
                return value > compareTo;
        }
    }
    return false;
};
export const evaluateCondition = ({ value, operator, compareTo, }) => {
    const isNot = operator.startsWith('not:');
    const regularOperator = isNot
        ? operator.replace('not:', '')
        : operator;
    const result = evaluateRegularConditions({
        value,
        operator: regularOperator,
        compareTo,
    });
    return isNot ? !result : result;
};
const isCondition = (condition) => {
    return 'operator' in condition;
};
const isConditionGroup = (condition) => {
    return 'conditions' in condition;
};
export const evaluateConditionGroup = (conditionGroup) => {
    if (isCondition(conditionGroup)) {
        return evaluateCondition(conditionGroup);
    }
    if (isConditionGroup(conditionGroup)) {
        const { passing = 'all', conditions } = conditionGroup;
        const results = conditions.map(evaluateConditionGroup);
        switch (passing) {
            case 'all':
                return results.every(result => result === true);
            case 'some':
                return results.some(result => result === true);
            case 'none':
                return results.every(result => result === false);
            case 'not:some':
                return results.some(result => result === false);
        }
    }
    return false;
};
//# sourceMappingURL=conditions.js.map